<script>
  import ImageAreaSection from '../EditorV2Pages/ImageAreaSection.svelte';
  import { useEditorV2Setup } from '../EditorV2Pages/setup.js';
  useEditorV2Setup();
</script>

<ImageAreaSection />